import React from 'react';
// ⚠️ PhonicsAtoZ.js 在 src/ 根目录，不是 src/phonics/！Vv踩坑
import PhonicsAtoZ from './PhonicsAtoZ';
// ⚠️ 数据文件在 src/phonics/，两个import前缀不同，禁止互相复制
import letterDataWw from './phonics/phonics_data_ww';

/**
 * Phonics Letter Ww 页面
 * 复用 PhonicsAtoZ 通用组件，只传入 Ww 数据
 */
function PhonicsWw() {
  return <PhonicsAtoZ letterData={letterDataWw} />;
}

export default PhonicsWw;
